// main.tsx — React entry point for DOMINUS Operator Console.
//
// Import order: design tokens first (CSS custom properties establish the
// root color values), then admin styles, then news section styles.

import './styles/tokens.css';
import './styles/admin.css';
import './styles/news.css';
import './styles/controls.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('[admin] Root element #root not found in index.html.');
}

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
